import request from "@/utils/request";
import { IProductsQuery } from "@/props/IProduct";

/**
 * 商品列表
 * @param {*} params
 * @returns
 */
export function getProductsApi(params: IProductsQuery) {
  return request({
    url: "/front/products",
    method: "GET",
    params,
  });
}

/**
 * 商品详情
 * @returns
 */
export function getProductsDetailApi(id: string | number) {
  return request({
    url: "/front/product/detail/" + id,
    method: "GET",
  });
}

/**
 * 最新商品推荐
 * @param {*} params
 * @returns
 */
export function getNewProductsApi(params: IProductsQuery) {
  return request({
    url: "/front/product/new",
    method: "GET",
    params,
  });
}

/**
 * 获取分类
 * @param {*} params
 * @returns
 */
export function getTopCategoryApi() {
  return request({
    url: "/front/top-category",
    method: "GET",
  });
}

/**
 * 首页商品
 * @param {*} params
 * @returns
 */
export function getIndexProductsApi(params: IProductsQuery, type?: string) {
  return request({
    url: "/front/index/products/" + type,
    method: "GET",
    params,
  });
}

/**
 * 首页数据
 * @returns
 */
export function getIndexDataApi() {
  return request({
    url: "/front/index",
    method: "GET",
  });
}

/**
 * 品牌列表
 * @returns
 */
export function getBrandsApi() {
  return request({
    url: "/front/brand",
    method: "GET",
  });
}

/**
 * 分类列表
 * @returns
 */
export function getCategoryApi() {
  return request({
    url: "/front/category",
    method: "GET",
  });
}
